import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useBackgroundRefetch } from '@/components/AppBar/NetworkPopover/hooks/useNetworks';
import { useGlobalState } from '@/global-state/useGlobalState';
import { mutationWithFeedback } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
const useCreateNetwork = () => {
  const $ = _c(8);
  const handleNetworkChange = useGlobalState(_temp);
  const refetchInBackground = useBackgroundRefetch();
  const router = useRouter();
  const {
    mutateAsync: createNetwork,
    isPending
  } = trpc.network.createNetwork.useMutation();
  let t0;
  if ($[0] !== createNetwork || $[1] !== handleNetworkChange || $[2] !== refetchInBackground || $[3] !== router) {
    t0 = name => mutationWithFeedback({
      mutation: createNetwork({
        name
      }),
      successText: "Created a new network",
      errorText: "Failed to create a new network",
      onSuccess: newId => {
        handleNetworkChange();
        router.push(`/${newId}`);
        refetchInBackground();
      }
    });
    $[0] = createNetwork;
    $[1] = handleNetworkChange;
    $[2] = refetchInBackground;
    $[3] = router;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const mutate = t0;
  let t1;
  if ($[5] !== isPending || $[6] !== mutate) {
    t1 = {
      mutate,
      isPending
    };
    $[5] = isPending;
    $[6] = mutate;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export default useCreateNetwork;
function _temp(state) {
  return state.handleNetworkChange;
}